import Utils from "../../utils/Utils";
import App from "../../App";
import Layout from "../../utils/Layout";
import { IObjectConfig } from "../../baseConfigs/layoutConfigShema";
import { TextStyle, Container, Matrix } from "pixi.js";
import MultiStyleText from "pixi-multistyle-text";
import { TextStyleSet } from "pixi-multistyle-text";
import GameModel from "../../model/GameModel";
import { isArray } from "lodash";
import Locale from '../../utils/Locale';

class TextField extends PIXI.Container {
    static fontMeasure: any = {};
    protected _fieldWidth: number;
    protected _fixFontSize: number | string = undefined;
    protected _fieldHeight: number;
    public bound: IObjectConfig;
    public boundShape: PIXI.Graphics;
    protected textShape: PIXI.Graphics;
    protected underline: PIXI.Graphics;
    public boundAnchor: { x: number; y: number } = { x: 0, y: 0 };
    public initStyle: ITextFieldStyleOptions;
    public scrollable: boolean = false;
    public wrappable: boolean = true;
    public centeredVertically: boolean = false;
    protected newStyle: ITextFieldStyleOptions;
    protected _text: PIXI.Text;
    private _isLabel: boolean;

    constructor(
        text: string,
        style: ITextFieldStyleOptions,
        definition: {
            multistyle?: boolean;
            bound?: IObjectConfig;
            anchor?: { x: number; y: number };
        }
    ) {
        super();
        if(style.fontFamily && !isArray(style.fontFamily)){
            let fontConfig = GameModel.gameConfig.fonts[style.fontFamily];
            if(fontConfig && fontConfig.padding) {
                style.padding =  Number(style.fontSize)*fontConfig.padding;
                style.trim = text != " " && text != null && text != undefined && text != "";
            }
        }
        this.initStyle = { ...style } ;
        if (definition.multistyle) {
            let multiStyle: TextStyleSet = {
                default: style,
                ...App.config.multyStyleFormats,
            };
            this._text = new MultiStyleText(text, multiStyle);
        } else {
            this._text = new PIXI.Text(text, this.initStyle);
        }
        this.textShape = new PIXI.Graphics();
        this.underline = new PIXI.Graphics();
        this.textShape.beginFill(0xfffb1b, 0);
        this.textShape.drawRect(
            0,
            0,
            Layout.scalePixels(this._text.width),
            Layout.scalePixels(this._text.height)
        );
        this.addChild(this._text);
        this.addChild(this.textShape);
        this.boundAnchor = definition.anchor;
        if (definition.bound) {
            this.bound = definition.bound;
            // this.applyBound();
        }
    }
    get fixFontSize(): number | string {
        return this._fixFontSize
    }

    // TO DO - Need to check for conditions for set the fixFontSize value
    set fixFontSize(value: number | string) {
        if (value !== this._fixFontSize) {
            this._fixFontSize = value;
        }
    }

    get anchor() {
        return this._text.anchor;
    }

    set anchor(anchor: PIXI.ObservablePoint) {
        this._text.anchor = anchor;
        this.boundAnchor = anchor;
    }

    get text(): string {
        return this._text.text;
    }

    set text(text: string) {
        text = String(
            text === "" || text === null || text === undefined ? " " : text
        );
        if (this._text.text === text) {
            return;
        }
        if(this._text.style.padding ) {
            this._text.style.trim = text != " ";
        }
        // this.dirty = true;
        this._text.text = text;

        // Apply the bounds - hide while positioning as currently it takes time
        // TODO: apply bounds needs to be refactored urgently!
        // this._text.visible = false;
        this.applyBound();
        // this._text.visible = true;
    }

    get style() {
        return this._text.style;
    }

    public get isLabel(): boolean {
        return this.isLabel;
    }

    public set isLabel(value: boolean) {
        this._isLabel = value;
    }

    public updateStyle(style:ITextFieldStyleOptions) {
        if(style.fontFamily && !isArray(style.fontFamily)){
            let fontConfig = GameModel.gameConfig.fonts[style.fontFamily];
            if(fontConfig && fontConfig.padding) {
                style.padding =  Number(style.fontSize)*fontConfig.padding;
                style.trim = this.text != " " && this.text != null && this.text != undefined && this.text != "";
            }

            if(fontConfig && fontConfig.fontWeight) {
                style.fontWeight =fontConfig.fontWeight;
            }
        }
        this.newStyle = { ...style } ;
        // TODO
    }

    public addUnderline() {
        this.underline.clear();
        let lineColor: string =   this.style.fill[0];
        lineColor = lineColor.replace("#", "0x");
        let lineWidth = Math.max(Layout.scalePixels(this.bound.height) / 20, Layout.scalePixels(5));
        let color = (parseInt(lineColor));
        this.underline.lineStyle(lineWidth, color)
        .moveTo(0, 0)
        .lineTo(this.textShape.width, 0);
        this.underline.pivot = new PIXI.Point(this.underline.width * this.boundAnchor.x, 0);
        this.underline.x = Layout.scalePixels(this.bound.width) - Layout.scalePixels(this.bound.width) * (1 - this.boundAnchor.x);
        this.underline.y =  Layout.scalePixels(this.bound.height) + this.underline.height;
        this.addChild(this.underline);
    }

    public removeUnderline() {
        this.underline.clear()
    }

    public applyBound(multiplier = 1, calculateFontSize: boolean = true) {
        if (!this.bound) {
            return;
        }

        if (App.config.useNewTextField && this.bound.id && Locale.getString(this.bound.id) !== this.bound.id) {
            this.removeChild(this.textShape);
            const x = Layout.scalePixels(this.bound.x);
            const y = Layout.scalePixels(this.bound.y);
            const width = Layout.scalePixels(this.bound.width);
            const height = Layout.scalePixels(this.bound.height);

            this._text.style.wordWrap = this.wrappable;
            this._text.style.wordWrapWidth = width;
            this._text.style.breakWords = true;

            if (this._isLabel) {
                this._text.style.fontSize = height * 0.6;
            } else {
                if (this.fixFontSize) {
                    this._text.style.fontSize = this.fixFontSize;
                } else {
                    if (calculateFontSize) {
                        let step = 1;

                        let style = this._text.style.clone();
                        style.fontSize = GameModel.gameConfig.minFontSize || 10;
                        let metrix = PIXI.TextMetrics.measureText(this._text.text, style, this.wrappable);

                        while (metrix.height < height) {
                            style.fontSize = Number(style.fontSize) + step;
                            metrix = PIXI.TextMetrics.measureText(this._text.text, style, this.wrappable);
                        }

                        this._text.style.fontSize = Math.floor(Number(metrix.style.fontSize) - step);
                    }
                }
            }

            let newX = x + width * this.boundAnchor.x;
            let newY = y + height * this.boundAnchor.y;
            this._text.position.set(newX, newY);
            return;
        }

        multiplier = this.calculateTextMultiplier();
        this._text.alpha = 0;
        let hadUnderline = this.underline.width;
        this.removeChild(this.underline);
        if (!this.boundShape) {
            this.boundShape = new PIXI.Graphics();
            this.boundShape.beginFill(0xfffb1b, 1);
            this.boundShape.drawRect(
                0,
                0,
                Layout.scalePixels(this.bound.width),
                Layout.scalePixels(this.bound.height)
            );
            this.boundShape.endFill();
            // this.addChild(this.boundShape);
        } else {
            this.boundShape.width = Layout.scalePixels(this.bound.width);
            this.boundShape.height = Layout.scalePixels(this.bound.height);
        }


        const initStrokeOffset =
            (this._text.style.strokeThickness || 0) / Layout.globalScale;
        let style = this.newStyle || this.initStyle;
        this._text.style.wordWrap = false;
        let newstyle = new TextStyle(style as any);
        let fontSize = Number(newstyle.fontSize) * multiplier;
        if (this.scrollable && !Layout.isLandscape()) {
            // this.mask = this.boundShape;
            fontSize = fontSize/Layout.portraitMultiplier;
        }
        newstyle.fontSize = Math.max(
            fontSize,
            (GameModel.gameConfig.minFontSize || 10) * multiplier
        );
        // this._text.text
        let metrix:any = PIXI.TextMetrics.measureText(
            this._text.text,
            newstyle,
            false
        );

        const scaledWidth = Layout.scalePixels(this.bound.width);
        const scaledHeight = Layout.scalePixels(this.bound.height);
        this.scale.x = 1;
        this.scale.y = 1;
        this._text.x = this._text.y = 0;

        for (let prop in newstyle) {
            if (prop !== "fontSize" && this._text.style[prop]) {
                this._text.style[prop] = newstyle[prop];
            }
        }

        // this._text.style.fontSize = newstyle.fontSize;

        let settleed = false;
        let lineBroke = false;

        Layout.setY(this, this.bound.y);
        Layout.setX(this, this.bound.x);

        let scale = Layout.scalePixels(this.bound.height) / metrix.height;

        let counter = 0;


        // while (!settleed) {
        if (
            metrix.width > scaledWidth ||
            ((!this.scrollable && metrix.height) || 0) > scaledHeight
        ) {
            if (
                (this.wrappable && this._text.text.indexOf(" ") != -1 &&
                    !newstyle.wordWrap)
            ) {


                let wrapSettled = false;
                newstyle.wordWrap = true;
                newstyle.wordWrapWidth = scaledWidth;
                let emptySpaceSize:any = PIXI.TextMetrics.measureText(
                    "_",
                    newstyle,
                    true
                    );

                metrix = PIXI.TextMetrics.measureText(this.text, newstyle);
                let lineCount = metrix.lines.length;
                // let thereIsAChanceNotToScaleAfterwards =  (metrix.width / scaledWidth) * metrix.lineHeight < scaledHeight;

                while (
                    !wrapSettled &&
                    lineCount > 1 &&
                    !this.scrollable &&
                    metrix.height / scaledHeight > metrix.width / scaledWidth
                ) {

                    counter++;

                    metrix = PIXI.TextMetrics.measureText(
                        this._text.text,
                        newstyle,
                        true
                    );

                    lineCount = metrix.lines.length;
                    let actualLineWidths = [...metrix.lineWidths];
                    actualLineWidths = actualLineWidths.filter(el => {
                        return el > 0;
                    });
                    let smalestLineWidth = actualLineWidths.length ? Math.min(...actualLineWidths) : 0;
                    let smallestIndex = metrix.lineWidths.indexOf(
                        smalestLineWidth
                    );
                    let smallestIsSingleWord = metrix.lines[smallestIndex]
                        .toString()
                        .split(" ").length;
                    let offset =
                        (smallestIsSingleWord > lineCount - 1
                            ? smalestLineWidth / (lineCount - 1)
                            : smalestLineWidth) + emptySpaceSize.width;
                    scale = Math.max(
                        Layout.scalePixels(this.bound.height) / metrix.height,
                        Layout.scalePixels(this.bound.width) / metrix.width
                    );
                    if (
                        lineCount > 1 &&
                        metrix.height / scaledHeight >
                        (newstyle.wordWrapWidth + offset) / scaledWidth
                    ) {
                        newstyle.wordWrapWidth =
                        newstyle.wordWrapWidth + offset;
                    } else {
                        wrapSettled = true;
                    }

                    if (newstyle.wordWrapWidth > scaledWidth * lineCount) {
                        wrapSettled = true;
                    }
                    if (counter > 15) {
                        throw new Error("Stack overflow in text field resize");
                    }
                }


                metrix = PIXI.TextMetrics.measureText(
                    this._text.text,
                    newstyle,
                    true
                );

            }
        }

        let coef = ((!this.scrollable && metrix.height) || 0) > scaledHeight ?
            Math.min(scaledWidth / metrix.width, scaledHeight / metrix.height) : scaledWidth / metrix.width;
        if (coef < 1) {
            let oldFS = newstyle.fontSize;
            newstyle.fontSize = Math.max(
                Number(newstyle.fontSize) * coef,
                (GameModel.gameConfig.minFontSize || 10) * multiplier
            );
            if (newstyle.wordWrap && oldFS != newstyle.fontSize) {
                newstyle.wordWrapWidth = newstyle.wordWrapWidth * coef;
            }
        }

        this._text.style.fontSize = newstyle.fontSize;

        metrix = PIXI.TextMetrics.measureText(this._text.text, newstyle, false);

        // App.instance.render();
        // App.instance.renderer.once("postrender",()=>{
        // if (this.width < metrix.width) {
            this.textShape.width = metrix.width;
            this.textShape.height = metrix.height;
            if(this.scrollable) {
                this.textShape.height = this.textShape.height + metrix.lineHeight;
            }
        // }



        this.removeChild(this._text);
        this.addChild(this.textShape);
        // if(this._text.text == "Infinate free spins battle. Sink one of the two ships to plunder the gold") {
        //     debugger;
        // }
        if (this.textShape.width > this.boundShape.width
            && !this.scrollable
            && (this.textShape.height < this.boundShape.height)) {
            // && (this.textShape.height / this.boundShape.height > this.textShape.width / this.boundShape.width)) {
            // Layout.testSetWidth(this, this.bound.width);
            if(this.wrappable) {

                newstyle.wordWrapWidth = scaledWidth / this.scale.x;
                newstyle.wordWrap = this.wrappable && newstyle.wordWrap;
                metrix = PIXI.TextMetrics.measureText(this._text.text, newstyle, newstyle.wordWrap);
                this.textShape.width = metrix.width;
                this.textShape.height = metrix.height;
            } else if((this.textShape.height / this.boundShape.height > this.textShape.width / this.boundShape.width)) {
                Layout.testSetWidth(this, this.bound.width);
                // newstyle.wordWrapWidth = scaledWidth / this.scale.x;
                // newstyle.wordWrap = this.wrappable && newstyle.wordWrap;
                metrix = PIXI.TextMetrics.measureText(this._text.text, newstyle, false);
                this.textShape.width = metrix.width;
                this.textShape.height = metrix.height;
            }

        }

        if (!this.scrollable && (this.textShape.height > this.boundShape.height)) {
            Layout.testSetHeight(this, this.bound.height);
            if(this.wrappable && metrix.width*this.scale.y <scaledWidth) {

                // newstyle.wordWrapWidth = scaledWidth / this.scale.y;
                // newstyle.wordWrap = this.wrappable && newstyle.wordWrap;
                metrix = PIXI.TextMetrics.measureText(this._text.text, newstyle, false);
                this.textShape.width = metrix.width;
                this.textShape.height = metrix.height;
                // Layout.testSetWidth(this, this.bound.width);
                if((this.textShape.height*this.scale.y / this.boundShape.height < this.textShape.width*this.scale.x / this.boundShape.width)) {
                    Layout.testSetWidth(this, this.bound.width);
                } else {
                    Layout.testSetHeight(this, this.bound.height);
                }
            }
        }

        // if(this._text.text == "Infinate free spins battle. Sink one of the two ships to plunder the gold") {
        //     debugger;
        // }
        this._text.style.wordWrap = (this.scrollable && newstyle.wordWrap) || (metrix.lines.length>1 && newstyle.wordWrap);
        this._text.style.wordWrapWidth = newstyle.wordWrapWidth;

        // this.removeChild(this.textShape);
        let measuredHeight = PIXI.TextMetrics.measureText(
            this._text.text,
            this._text.style
        ).height;

        this.addChild(this._text);
        if(!this.scrollable) {
            // this.removeChild(this.textShape);
        }

        // TODO: add the option to center text into the container
        // Layout.setY(
        //     this._text,
        //     (this.bound.height - measuredHeight) * (0.5 - this.anchor.y) -
        //         initStrokeOffset
        // );

        if (!this.scrollable && this.centeredVertically) {
            this.centerVertical()
        } else {
            Layout.setY(
                this._text,
                -initStrokeOffset
            );
        }
        Layout.setX(
            this._text,
            (this.boundAnchor.x * (this.bound.width + initStrokeOffset)) /
            this.scale.x
        );
        // this._text.visible = true;
        this._text.style.fontSize = Math.round(this._text.style.fontSize);
        this._text.alpha = 1;

        if (hadUnderline) {
            this.addUnderline();
        }

    }

    public centerVertical() {
        if(this.scrollable) {
            return;
        }
        this.centeredVertically = true;
        const initStrokeOffset =
            (this._text.style.strokeThickness || 0) / Layout.globalScale;
        let measuredTxt:any = PIXI.TextMetrics.measureText(
            this._text.text,
            this._text.style
        );

        let measuredHeight = measuredTxt.height / Layout.globalScale;

        Layout.setY(this, this.bound.y + ((this.bound.height - measuredHeight * this.scale.y)) / 2);
    }

    protected calculateTextMultiplier(): number {
        return Layout.isLandscape() ? 1 : Layout.portraitMultiplier;
    }
}
export interface ITextFieldStyleOptions {
    align?: string;
    breakWords?: boolean;
    dropShadow?: boolean;
    dropShadowAlpha?: number;
    dropShadowAngle?: number;
    dropShadowBlur?: number;
    dropShadowColor?: string | number;
    dropShadowDistance?: number;
    fill?: string | string[] | number | number[] | CanvasGradient | CanvasPattern;
    fillGradientType?: number;
    fillGradientStops?: number[];
    fontFamily?: string | string[];
    fontSize?: number | string;
    fontStyle?: string;
    fontVariant?: string;
    fontWeight?: string;
    leading?: number;
    letterSpacing?: number;
    lineHeight?: number;
    lineJoin?: string;
    miterLimit?: number;
    padding?: number;
    stroke?: string | number;
    strokeThickness?: number;
    trim?: boolean;
    textBaseline?: string;
    whiteSpace?: string;
    wordWrap?: boolean;
    wordWrapWidth?: number;
}
export default TextField;
